import React, { useContext, useEffect, useState } from 'react';
import { Accordion, AccordionContext, Card, Form } from 'react-bootstrap';
import httpService from '../../services/httpService';
import config from '../../config/config';
import { PhotoSwipe } from 'react-photoswipe';
import icons from '../../assets/icons/icons';
import color from '../../assets/colors';
import { MyToast } from '../Toast/Toast';
import { connect } from 'react-redux';
import { useRouter } from 'next/router';


const ContactFormAccordion = (props: any) => {
  var FormData = require('form-data');
  let formData = new FormData();
  const history = useRouter()

  const [validated, setValidated] = useState(false);
  const [state, setstate]: any = useState({});
  const [popUp, setpopUp] = useState({ images: [{}], status: false });
  const [file, setfile]: any = useState({});
  const [country, setcountry] = useState([]);
  const [toast, setToast]: any = useState({ message: '', visible: false, timeOut: 5000, type: 'success' });


  const resetToast = () => {
    setTimeout(() => {
      setToast({ ...toast, visible: false });
    }, 5000);
  };



  const [validationErrorList, setValidationErrorList]: any = useState({})
  const handleSubmit = (event: any) => {
    const form = event.currentTarget;
    setValidated(true);
    event.preventDefault();
    event.stopPropagation();
    if (form.checkValidity() === false || Object.keys(validationErrorList).length !== 0) {
      return;
    }
    formData.delete('data');
    formData.append('data', JSON.stringify(state));
    props.showLoader();
    httpService.invokeApi(
      {
        url: config.serviceUrlMain+props.data.Form.actionUrl,
        data: formData,
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' }
      },
      (success: boolean, res: any) => {
        if (success && res.statusCode !== 400) {
          event.target.reset();
          setValidated(false);
          setstate({});
          setfile({});
          props.hideLoader();
          formData = new FormData();
          history.push('/connect-confirmation')
        }
        else {
          props.hideLoader();
          if (res.data.errors instanceof Object) {
            let errors = Object.values(res.data.errors);
            if (errors.length > 0) {
              setToast({ ...toast, message: errors[0], visible: true, type: 'failure' });
              resetToast();
            }
          }
        }
      }
    );
  };

  const getData = async () => {
    httpService.invokeApi({ method: 'get', url: config.endpoints.country }, (success: boolean, response: any) => {
      setcountry(response);
    });
  };

  useEffect(() => {
    getData();
  }, []);

  const clearFile = (name: string) => {
    setfile({ ...state, [name]: null });
    setstate({ ...state, [name]: null });
  };
  const renderingitem = (element: any, index?: any) => {
    if (element.type === 'submit') {
      return <input type={element.type} key={index} className="btn-contactbutton" name={element.name} />;
    } else if (element.type === 'radio') {
      return (
        element && (
          <div className="col-md-6 mb-3" key={index}>
            <label className="form-label form-label-bold">
              {element.label}
              {element.required && <span className={'error-message-astrid-show'}>*</span>}
              {element.infoIcon && (
                <div
                  onClick={() => {
                    setpopUp({
                      status: true,
                      images: [
                        {
                          src: config.baseUrl + element.infoImage.url,
                          h: element.infoImage.height,
                          w: element.infoImage.width
                        }
                      ]
                    });
                  }}
                  className={'app-info-popup'}
                  style={{ backgroundImage: `url(${element.infoIcon ? config.baseUrl + element.infoIcon.url : ''})` }}
                />
              )}
            </label>
            {element.values.map((radioitem: any, key: number) => {
              return (
                <div className="form-check" key={key}>
                  <Form.Check
                    type={element.type}
                    name={element.name}
                    value={radioitem.value}
                    label={radioitem.name}
                   
                    required={element.required}
                  />
                </div>
              );
            })}
          </div>
        )
      );
    } else if (element.type === 'select') {
      if (!state[`${element.name}`]) {
        setstate({ ...state, [element.name]: element.values[1] });
      }
      if (element.__component === undefined) {
        return (

          element && (
            <div className="form-row mb-3" key={index}>
              <div className="col">
                <label className="form-label form-label-bold">


                  {element.infoIcon && (
                    <div
                      onClick={() => {
                        setpopUp({
                          status: true,
                          images: [
                            {
                              src: config.baseUrl + element.infoImage.url,
                              h: element.infoImage.height,
                              w: element.infoImage.width
                            }
                          ]
                        });
                      }}
                      className={'app-info-popup'}
                      style={{ backgroundImage: `url(${element.infoIcon ? config.baseUrl + element.infoIcon.url : ''})` }}
                    />
                  )}
                </label>
                <select
                  className="form-control"
                  name={element.name}
                  required={element.required}
                  aria-label={element.name}
                  defaultValue={element.values[1]}
                >
                  <option value="" disabled>
                    select an {element.name}
                  </option>
                  {country && country.map((selectitem: any, key: number) => {
                    return (
                      <React.Fragment key={key}>
                        <option value={selectitem.name}>{selectitem.name} </option>
                      </React.Fragment>
                    );
                  })}
                </select>
                {element.label}
                <Form.Control.Feedback type="invalid">{element.errorMessage}</Form.Control.Feedback>
              </div>
            </div>
          )
        );
      } else {
        return (

          element && (
            <div className="form-row mb-3" key={index}>
              <div className="col">
                <label className="form-label form-label-bold">
                  {element.label}
                  {element.required && <span className={'error-message-astrid-show'}>*</span>}
                  {element.infoIcon && (
                    <div
                      onClick={() => {
                        setpopUp({
                          status: true,
                          images: [
                            {
                              src: config.baseUrl + element.infoImage.url,
                              h: element.infoImage.height,
                              w: element.infoImage.width
                            }
                          ]
                        });
                      }}
                      className={'app-info-popup'}
                      style={{ backgroundImage: `url(${element.infoIcon ? config.baseUrl + element.infoIcon.url : ''})` }}
                    />
                  )}
                </label>
                <select
                  className="form-control"
                  name={element.name}
                  required={element.required}
                 
                  defaultValue={element.values[1]}
                >
                  <option value="" disabled>
                    select an {element.name}
                  </option>
                  {country && country.map((selectitem: any, key: number) => {
                    return (
                      <React.Fragment key={key}>
                        <option value={selectitem.name}>{selectitem.name} </option>
                      </React.Fragment>
                    );
                  })}
                </select>
                <Form.Control.Feedback type="invalid">{element.errorMessage}</Form.Control.Feedback>
              </div>
            </div>
          )
        );
      }
    } else if (element.type === 'textarea') {
      return (
        element && (
          <div className="form-row mb-3" key={index}>
            <div className="col">
              <label className="form-label form-label-bold">
                {element.label}
                {element.required && <span className={'error-message-astrid-show'}>*</span>}
                {element.infoIcon && (
                  <div
                    onClick={() => {
                      setpopUp({
                        status: true,
                        images: [
                          {
                            src: config.baseUrl + element.infoImage.url,
                            h: element.infoImage.height,
                            w: element.infoImage.width
                          }
                        ]
                      });
                    }}
                    className={'app-info-popup'}
                    style={{ backgroundImage: `url(${element.infoIcon ? config.baseUrl + element.infoIcon.url : ''})` }}
                  />
                )}
              </label>
              <textarea
                className="form-control"
                name={element.name}
                // placeholder={element.name}
                rows={4}
                cols={50}
                required={element.required}

              />
              <Form.Control.Feedback type="invalid">{element.errorMessage}</Form.Control.Feedback>
            </div>
          </div>
        )
      );
    } else if (element.type === 'file') {
      return (
        element && (
          <div className="form-row mb-3" key={index}>
            <div className="col">
              <label className="form-label form-label-bold">
                {element.label}
                {element.required && <span className={'error-message-astrid-show'}>*</span>}
                {element.infoIcon && (
                  <div
                    onClick={() => {
                      setpopUp({
                        status: true,
                        images: [
                          {
                            src: config.baseUrl + element.infoImage.url,
                            h: element.infoImage.height,
                            w: element.infoImage.width
                          }
                        ]
                      });
                    }}
                    className={'app-info-popup'}
                    style={{ backgroundImage: 'url(' + config.baseUrl + element.infoIcon.url + ')' }}
                  />
                )}
              </label>
              <div className="form-group files color">
                {file[`${element.name}`] && (
                  <span
                    className="app-clear"
                    onClick={() => {
                      clearFile(element.name);
                    }}
                  >
                    {icons.close('#000', '')}
                  </span>
                )}
                <Form.Control
                  id={element.type}
                  type={element.type}
                  name={element.name}
                  required={element.required}
                  // placeholder={element.name}
                  value={state['element.name']}
                />
                <div className="app-file-upload-container">
                  {file[`${element.name}`] ? (
                    <div className="app-selcted-image">
                      <div className="app-image-preview">
                        <i className="fas fa-file fa-2x" />
                      </div>
                      <div className="app-details">
                        <span>{(Math.round((file[`${element.name}`].size / 1048576) * 100) / 100).toFixed(3)}MB</span>
                        <span>{file[`${element.name}`].name}</span>
                      </div>
                    </div>
                  ) : (
                    <React.Fragment>
                      <i className="fas fa-box fa-2x" />
                      <span className="m-t-10">Click or drag a file to this area to upload.</span>
                    </React.Fragment>
                  )}
                </div>
                {element && <Form.Control.Feedback type="invalid" id={element.name}>{element.errorMessage}</Form.Control.Feedback>}
              </div>
            </div>
          </div>
        )
      );
    } else {
      if (element.__component === undefined) {
        return (
          element && (
            <div className="form-row mb-3" key={index}>
              <div className="col">
                <label className="form-label form-label-bold">

                  {element.infoIcon && (
                    <div
                      onClick={() => {
                        setpopUp({
                          status: true,
                          images: [
                            {
                              src: config.baseUrl + element.infoImage.url,
                              h: element.infoImage.height,
                              w: element.infoImage.width
                            }
                          ]
                        });
                      }}
                      className={'app-info-popup'}
                      style={{ backgroundImage: 'url(' + config.baseUrl + element.infoIcon.url + ')' }}
                    />
                  )}
                </label>
                <Form.Control type={element.type}
                  onChange={(event: any) => {
                    changeHandlers(event, element);
                  }}
                  name={element.name} required={element.required} />
                {element.label}
                <div className="Contact-form-errorMessage">{validationErrorList[element.name]}</div>
                <Form.Control.Feedback type="invalid">{element.errorMessage}</Form.Control.Feedback>
              </div>
            </div>
          )
        );
      } else {
        return (
          element && (
            <div className="form-row mb-3" key={index}>
              <div className="col">
                <label className="form-label form-label-bold">
                  {element.label}
                  {element.required && <span className={'error-message-astrid-show'}>*</span>}
                  {element.infoIcon && (
                    <div
                      onClick={() => {
                        setpopUp({
                          status: true,
                          images: [
                            {
                              src: config.baseUrl + element.infoImage.url,
                              h: element.infoImage.height,
                              w: element.infoImage.width
                            }
                          ]
                        });
                      }}
                      className={'app-info-popup'}
                      style={{ backgroundImage: 'url(' + config.baseUrl + element.infoIcon.url + ')' }}
                    />
                  )}
                </label>
                <Form.Control type={element.type}
                  onChange={(event: any) => {
                    changeHandlers(event, element);
                  }}
                  name={element.name} required={element.required}  />
                <div className="Contact-form-errorMessage">{validationErrorList[element.name]}</div>
                <Form.Control.Feedback type="invalid">{element.errorMessage}</Form.Control.Feedback>
              </div>
            </div>
          )
        );
      }

    }
  };


  const changeHandlers = (event: any, element: any) => {
    const Name = event.target.name;
    const Value = event.target.value;

    if (element.validationPattern) {
      let res = new RegExp(element.validationPattern, 'g');
      if (res.test(Value)) {
        let validationerrror = { ...validationErrorList }
        delete validationerrror[Name];
        setValidationErrorList(validationerrror)

      } else {

        setValidationErrorList({ ...validationErrorList, [Name]: element.validationMessage })
      }

    }

    console.log()


  }

  const FormGroups = (formData: any) => {
    return formData.map((items: any, i: number) => {
      return (
        <div className="form-row" key={i}>
          {items.map((item: any, i: number) => {
            return (
              <div key={i} className="col">
                {renderingitem(item, i)}
              </div>
            );
          })}
        </div>
      );
    });
  };

  const mapFormGroup = (formData: any) => {
    let row: any = [];
    let rowElement: any[] = [];
    formData.map((e: any) => {
      rowElement.push(e);
      if (e.rowBreak) {
        row.push(rowElement);
        rowElement = [];
      }
      return null;
    });
    return FormGroups(row);
  };

  const renderForm = (element: any, index?: any) => {
    switch (element.__component) {
      case 'form.form-element':
        return <React.Fragment key={index}>{renderingitem(element)}</React.Fragment>;
      case 'form.form-group-element':
        return (
          <React.Fragment key={index}>
            <label className="form-label form-label-bold">{element.groupLabel}  {<span className={'error-message-astrid-show'}>*</span>}</label>

            {mapFormGroup(element.FormElements)}
          </React.Fragment>
        );
    }
  };

  const changeHandler = (FormName: string, FormValue: any, FormType: string, fileName?: any) => {

    if (FormType === 'file') {
      if (fileName.length === 1) {
        const file = fileName[0];
        formData.delete(`files.${FormName}`);
        formData.append(`files.${FormName}`, file, file.name);
        setfile({ ...file, [FormName]: file });
      } else {
        formData.delete(`files.${FormName}`);
        setfile({ ...file, [FormName]: null });
      }
    } else {
      setstate({ ...state, [FormName]: FormValue });
    }
  };

  const CustomToggle = ({ eventKey }: any) => {
    const currentEventKey = useContext(AccordionContext);
    const isCurrentEventKey = currentEventKey === eventKey;
    if (isCurrentEventKey) {
      return icons.negetive(color.$white, '');
    } else {
      return icons.plus(color.$white, '');
    }
  };

  return (
    <div className="ContactFormAccordion-container">
      <MyToast message={toast.message} visible={toast.visible} type={toast.type} timeOut={toast.timeOut} />
      <Accordion >
        <Card>
          <Accordion.Toggle
            as={Card.Header}
            eventKey="0"
            className="ContactFormAccordion-single-bg ContactFormAccordion-header"
            style={{ backgroundColor: `${props.data.titleBackgroundColor ? props.data.titleBackgroundColor : '#FF610F'}` }}
            tabIndex={0}
            aria-expanded={true}
          >
            <span >{props.data.title}</span>
            <CustomToggle eventKey="0"  />
          </Accordion.Toggle>
          <Accordion.Collapse eventKey="0">
            <div className="ContactFormAccordion-body" tabIndex={0}>
              <span className={props.data.title === 'GENERAL INFO' ? 'generalHeaderInfo': ''}>{props.data.subTitle}</span>
              <Form
                validated={validated}
                noValidate
                onChange={(event: any) => {
                  changeHandler(event.target.name, event.target.value, event.target.type, event.target.files);
                }}
                onSubmit={handleSubmit}

              >
                {props.data.Form.Elements?.map((items: any, index: number) => renderForm(items, index))}
              </Form>
            </div>
          </Accordion.Collapse>
        </Card>
      </Accordion>
      <PhotoSwipe
        items={popUp.images}
        isOpen={popUp.status}
        onClose={() => {
          setpopUp({ ...popUp, status: !popUp.status });
        }}
      />
    </div>
  );
};

const mapState = (state: any) => {
  return {};
};

const mapDispatch = (dispatch: any) => {
  return {
    showLoader: () => dispatch({ type: 'LOADER_SHOW' }),
    hideLoader: () => dispatch({ type: 'LOADER_HIDE' })
  };
};

export default connect(
  mapState,
  mapDispatch
)(ContactFormAccordion);
